var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0B90B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2761 16L7.69941 18.5952L5.09785 16L7.69845 13.3817L10.2761 16ZM16.5753 9.65794L21.0133 14.1261L23.6148 11.5088L16.5753 4.44446L9.5358 11.5319L12.1374 14.1492L16.5753 9.65794ZM25.4522 13.3817L22.8745 16L25.4751 18.6183L28.0748 16L25.4522 13.3817ZM16.5753 22.3421L12.1374 17.8508L9.5358 20.4691L16.5753 27.5556L23.6148 20.4682L21.0133 17.8508L16.5753 22.3421ZM16.5753 18.5962L19.1759 15.9769L16.5753 13.3827L13.9747 16L16.5753 18.5962Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBinance);
export default __webpack_public_path__ + "static/media/ic_binance.c3506a25a45709f41f92cc317e7a8625.svg";
export { ForwardRef as ReactComponent };